
import {Component, Vue} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import {Getter} from "vuex-class";

@Component({})
export default class Invoices extends Vue {
    @Getter private currentUser: any;
    @Getter private envCompanyId: number|null;

    private smsRemaining: number = null;
    private rules: object = formRules;
    private overpriceLimit: number = null;
    private currentOverpriceLimit: number = 0.00;
    private loading: boolean = false;
    private valid: boolean = false;

    get hasOverpriceLimitChanged(): boolean {
        return this.currentOverpriceLimit !== this.overpriceLimit;
    }

    private async mounted(): Promise<void> {
        this.currentOverpriceLimit = await this.$store.dispatch(`companies/getOverpriceLimit`, {
            id: this.envCompanyId,
        }) || "0.00";
        this.overpriceLimit = this.currentOverpriceLimit;
        await this.reset();
    }

    private async reset(): Promise<void> {
        await this.getSmsRemaining();
    }
    private async getSmsRemaining(): Promise<void> {
        await this.$store.dispatch(`companies/getSmsRemaining`, {
          id: this.envCompanyId,
        }).then((smsRemaining) => {
          this.smsRemaining = smsRemaining;
        })
        .catch((err) => {
          this.$store.commit("alerts/displayError", {
              msg: err,
          });
        });
    }

    private async updateCompanyOverpriceLimit(): Promise<void> {
        if (!this.valid) {
            return;
        }
        this.loading = true;
        await this.$store.dispatch("companies/updateOverpriceLimit", {
            id: this.envCompanyId,
            overpriceLimit: this.overpriceLimit,
        }).then(() => {
            this.loading = false;
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("alerts.sms.overpriceLimitEditSuccess"),
            });
        }).catch((err) => {
            this.loading = false;
            this.$store.commit("alerts/displayError", {
                msg: this.$t(`register.error.${err.response.data.type}`),
            });
        });
    }
}
